import { filterOnlyHavingParameterSet } from '../filters/byParameterName.js';
import StringifiedParameterFormatter from '../formatters/StringifiedParameterFormatter.js';
import buildFiltersForPitchingChart from '../filters/pitchingChartFilters.js';
import UniqueResultParametersProvider from './UniqueResultParametersProvider.js';
import { PitchReprocessed, PitchData, ResultData, PitchType } from '../enums/index.js';
import { ChartSeries, Series, BaseballResultsProcessor } from '../entities/index.js';

const buildFiltersArray = function({
    // tagging context
    pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness,
    // scoring context 
    outs, balls, strikes, runnersOn,
}) {
    let pitchingChartFilters = buildFiltersForPitchingChart({
        pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness,
        outs, balls, strikes, runnersOn
    });

    return pitchingChartFilters.concat(
        filterOnlyHavingParameterSet(ResultData.getDataPath(PitchData.StrikeZoneFront.key))
    );
};

const getSeriesForLocationChart = function(
    results, customResultsProcessor,
    {
        // tagging context
        pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness,
        // scoring context 
        outs, balls, strikes, runnersOn,
    } = {}
) {
    let chartSeries = [];
    let resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    let chartFilters = buildFiltersArray({
        pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness,
        outs, balls, strikes, runnersOn,
    });

    let pitchesWithLocationOnly =  resultsProcessor.filterData(results, chartFilters);
    let resultsPerPitchType = resultsProcessor.groupData(
        pitchesWithLocationOnly, [ResultData.getDataPath(PitchData.Classification.key)],
        [], true, PitchType.Unidentified.key
    );
    for (let pitchType in resultsPerPitchType) {
        let resultsMapped = resultsProcessor.mapCollectionProperties(resultsPerPitchType[pitchType], [
            [ResultData.Id.key],
            ResultData.getDataPath(PitchData.StrikeZoneFront.key)
        ]);

        const dataForPitchType = new Series(pitchType, 2);

        for (let i = 0; i < resultsMapped.length; i++) {
            let formatted = StringifiedParameterFormatter(
                resultsMapped[i][PitchData.StrikeZoneFront.key], ';', PitchData.StrikeZoneFront.stringifiedAs, parseFloat
            );

            // TODO - if we need to mirror it -  x: formatted.X * -1,
            dataForPitchType.add(resultsMapped[i][ResultData.Id.key], formatted.X, formatted.Z);
        }

        chartSeries.push(dataForPitchType);
    }

    return new ChartSeries(chartSeries, Object.keys(resultsPerPitchType));
};

const listUniqueParametersForLocationChart = function(
    results, customResultsProcessor,
    {
        // tagging context
        pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness,
        // scoring context
        outs, balls, strikes, runnersOn,
    } = {},
    parameters,
    combinedPitchResult
) {
    parameters = parameters || [
        // tagging context
        [ResultData.BatterTagId.key],
        [ResultData.TagId.key],
        ResultData.getDataPath(PitchData.Result.key),
        ResultData.getDataPath(PitchData.Classification.key),
        ResultData.getDataPath(PitchData.Mechanics.key),
        ResultData.getDataPath(PitchData.SwingHandedness.key),
        ResultData.getDataPath(PitchReprocessed.StrikeZonePositionR.key),
        // scoring context
        ResultData.getDataPath(PitchData.BeforePlayOuts.key),
        ResultData.getDataPath(PitchData.BeforePlayBalls.key),
        ResultData.getDataPath(PitchData.BeforePlayStrikes.key),
        ResultData.getDataPath(PitchData.BeforePlayRunnersOn.key),
    ];

    const resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
    const chartFilters = buildFiltersArray({
        pitcherId, pitchResults, pitchTypes, pitchSet, zones, batterIds, batterHandedness,
        outs, balls, strikes, runnersOn
    });

    const pitchesWithLocationOnly = resultsProcessor.filterData(results, chartFilters);
    
    return UniqueResultParametersProvider(pitchesWithLocationOnly, parameters, resultsProcessor, combinedPitchResult);
};

export default getSeriesForLocationChart;

export {
    getSeriesForLocationChart, listUniqueParametersForLocationChart
};